<template>
  <div>
    <!-- 页面标题抬头 -->
    <el-page-header @back="$router.push('./.')" :content="title" />
    <el-form
      ref="form"
      :model="form"
      size="small"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-card style="min-height: 540px">
            <div slot="header">基本信息</div>
            <div>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="品牌" prop="brand">
                    <el-select
                      v-model="form.brand"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请输入关键词"
                      :remote-method="remoteMethod"
                      :loading="loading"
                    >
                      <el-option
                        v-for="(v, index) in brandOption"
                        :key="index"
                        :label="v"
                        :value="v"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="名称" prop="name">
                    <el-input v-model="form.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="生产许可证" prop="productionLicense">
                    <el-input
                      v-model="form.productionLicense"
                      placeholder="生产许可证"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="4">
                  <el-form-item label="包装形式">
                    <el-radio-group v-model="form.packagingForm">
                      <el-row>
                        <el-col :span="12">
                          <el-radio-button label="袋">袋</el-radio-button>
                        </el-col>
                        <el-col :span="12">
                          <el-radio-button label="桶">桶</el-radio-button>
                        </el-col>
                      </el-row>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="包装净含量" prop="packingWeight">
                    <el-input v-model="form.packingWeight" placeholder="含量">
                      <el-select
                        v-model="form.unit"
                        slot="append"
                        placeholder="单位"
                        style="width: 70px"
                      >
                        <el-option
                          v-for="v in unitOption"
                          :key="v.id"
                          :label="v.label"
                          :value="v.value"
                        />
                      </el-select>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item label="生产厂家" prop="manufacturer">
                    <el-select
                      v-model="form.manufacturer"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请输入关键词"
                      :remote-method="manufacturerChnage"
                      :loading="loading"
                    >
                      <el-option
                        v-for="(v, index) in manufacturerOption"
                        :key="index"
                        :label="v"
                        :value="v"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card style="min-height: 540px">
            <div slot="header">分类和成分</div>
            <div>
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item label="类型" prop="type">
                    <el-radio-group v-model="form.type" @change="typeChoose">
                      <el-radio :label="'化肥'">化肥</el-radio>
                      <el-radio :label="'农药'">农药</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="子类型" prop="subtype">
                    <el-select
                      v-model="form.subtype"
                      placeholder="请选择子类型"
                    >
                      <el-option
                        v-for="(v, index) in childrenOption"
                        :key="index"
                        :label="v"
                        :value="v"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    v-if="form.type == '农药'"
                    label="剂型"
                    prop="subtype"
                  >
                    <el-select v-model="form.dosageForm" placeholder="剂型">
                      <el-option
                        v-for="(v, index) in shapeOption"
                        :key="index"
                        :label="v"
                        :value="v"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    v-if="form.type == '农药'"
                    label="毒性"
                    prop="subtype"
                  >
                    <el-select v-model="form.toxicity" placeholder="毒性">
                      <el-option
                        v-for="(v, index) in toxicityOption"
                        :key="index"
                        :label="v.label"
                        :value="v.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="成分及含量">
                    <el-row :gutter="10" v-if="this.form.type == '化肥'">
                      <el-col :span="8">
                        <el-card shadow="never">
                          <span slot="header">大量元素</span>
                          <el-checkbox-group v-model="form.checkList">
                            <el-checkbox label="氮" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[0].nContent"
                            />
                            <el-checkbox label="磷" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[0].pConcent"
                            />
                            <el-checkbox label="钾" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[0].kContent"
                            />
                          </el-checkbox-group>
                        </el-card>
                      </el-col>
                      <el-col :span="8">
                        <el-card shadow="never">
                          <span slot="header">中量元素</span>
                          <el-checkbox-group v-model="form.checkList">
                            <el-checkbox label="钙" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[1].gContent"
                            />
                            <el-checkbox label="镁" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[1].mContent"
                            />
                          </el-checkbox-group>
                        </el-card>
                      </el-col>
                      <el-col :span="8">
                        <el-card shadow="never">
                          <span slot="header">微量元素</span>
                          <el-checkbox-group v-model="form.checkList">
                            <el-checkbox label="砷"></el-checkbox>
                            <el-input
                              size="mini"
                              v-model="form.objContent[2].sContent"
                            />
                            <el-checkbox label="硼" />
                            <el-input
                              size="mini"
                              v-model="form.objContent[2].pContent"
                            />
                          </el-checkbox-group>
                        </el-card>
                      </el-col>
                    </el-row>
                    <div class="ingredientBox" v-if="this.form.type == '农药'">
                      <el-card
                        v-for="(item, index) in form.biocideOption"
                        :key="index"
                      >
                        <el-checkbox-group
                          v-model="form.checkList"
                          @change="handleSelect"
                        >
                          <div v-for="(i, num) in item" :key="num">
                            <el-checkbox :label="i.label" />
                            <el-input size="mini" v-model="i.value" />
                          </div>
                        </el-checkbox-group>
                      </el-card>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- 页面主体内容 -->

      <div style="text-align: center; margin-top: 20px">
        <el-button type="warning" @click="clearFrom">清空</el-button>
        <el-button type="primary" @click="save">填好了，保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import {
  addInputs,
  updateInputsById,
  getInputsById,
  getInputsBrands,
  getInputsManufacturers,
} from '@/api/inputs.js'
import typeOption from './inputs-types'
import shapeType from './medical-forms'
export default {
  name: 'InputsEdit',
  data() {
    return {
      form: {
        id: undefined,
        count: '', //净含量
        desc: '',
        name: '',
        type: '',
        subtype: '',
        countType: '', //单位
        brand: '',
        dosageForm: '',
        toxicity: '',
        manufacturer: '',
        productionLicense: '',
        packingWeight: '', //净含量(字符穿拼接)
        packagingForm: '',
        checkList: [],
        objContent: [
          {
            nContent: '',
            pConcent: '',
            kContent: '',
          },
          {
            gContent: '',
            mContent: '',
          },
          {
            sContent: '',
            pContent: '',
          },
        ],
        data: '',
        unit: '',
        biocideOption: [
          [
            {
              label: '杀菌剂',
              value: '',
            },
            {
              label: '杀螨剂',
              value: '',
            },
            {
              label: '杀虫剂',
              value: '',
            },
          ],
          [
            {
              label: '除草剂',
              value: '',
            },
            {
              label: '生长调节剂',
              value: '',
            },
          ],
          [
            {
              label: '农药助剂',
              value: '',
            },
            {
              label: '其他农药',
              value: '',
            },
          ],
        ],
      },
      shapeOption: [
        {
          label: '水剂',
          value: '水剂',
        },
        {
          label: '颗粒',
          value: '颗粒',
        },
        {
          label: '粉末',
          value: '粉末',
        },
      ],
      toxicityOption: [
        {
          label: '无毒',
          value: '无毒',
        },
        {
          label: '微毒',
          value: '微毒',
        },
        {
          label: '剧毒',
          value: '剧毒',
        },
      ],
      typeOption: [],
      childrenOption: [],
      brandOption: [],
      unitOption: [
        {
          label: 'kg',
          value: 'kg',
        },
        {
          label: 'ml',
          value: 'ml',
        },
      ],
      pakageOption: [
        {
          label: '袋',
          value: '袋',
        },
        {
          label: '桶',
          value: '桶',
        },
      ],
      /**
       * 成分及含量
       */
      selectGroup: [],
      rules: {
        type: [
          { required: true, message: '请选择投入品类型', trigger: 'blur' },
        ],
        subtype: [{ required: true, message: '请选择子类型', trigger: 'blur' }],
        name: [
          { required: true, message: '请输入投入品名称', trigger: 'blur' },
        ],
        manufacturer: [
          { required: true, message: '请输入生产厂家', trigger: 'blur' },
        ],
        packingWeight: [
          { required: true, message: '请填写包装净含量', trigger: 'blur' },
        ],
        productionLicense: [
          { required: true, message: '请输入生产许可证', trigger: 'blur' },
        ],
      },
      loading: false,
      manufacturerOption: [],
    }
  },
  computed: {
    /**
     * 当前要编辑的投入品的id，如果为非数NaN，则表示要新增
     */
    id() {
      return parseInt(this.$route.params.id)
    },
    /**
     * 页面标题，根据id计算得出，如果id非数，则为新增，否则为编辑
     */
    title() {
      return `${isNaN(this.id) ? '新增' : '编辑'}投入品`
    },
  },
  mounted() {
    if (this.$route.params.id !== 'newone') {
      this.formEditor()
    }
    this.shapeOption = shapeType
  },
  methods: {
    /**
     * 选中事件
     */
    handleSelect(val) {
      this.selectGroup = val
    },
    //类型
    typeChoose() {
      if (this.form.type == '化肥') {
        this.childrenOption = typeOption[0].children
      } else if (this.form.type == '农药') {
        this.childrenOption = typeOption[1].children
      }
    },
    //厂家下拉查询
    manufacturerDataGet() {
      getInputsManufacturers(name).then((data) => {
        this.manufacturerOption = data.data
      })
    },
    manufacturerChnage(name) {
      this.loading = true
      this.form.manufacturer = name
      if (name !== '') {
        setTimeout(() => {
          this.loading = false
          this.manufacturerDataGet(name)
        })
      }
    },
    remoteMethod(brandName) {
      this.loading = true
      this.form.brand = brandName
      if (brandName !== '') {
        setTimeout(() => {
          this.loading = false
          this.brandDateGet(brandName)
        })
      } else {
      }
    },
    //品牌下拉查询
    brandDateGet(brandName) {
      getInputsBrands(brandName).then((data) => {
        this.brandOption = data.data
      })
    },
    formEditor() {
      getInputsById(this.id).then((data) => {
        this.form.id = data.data.id
        this.form.type = data.data.type
        this.form.subtype = data.data.subtype
        this.form.brand = data.data.brand
        this.form.name = data.data.name
        this.form.manufacturer = data.data.manufacturer
        this.form.productionLicense = data.data.productionLicense
        this.form.packingWeight = data.data.packingWeight
        this.form.unit = data.data.unit
        this.form.dosageForm = data.data.dosageForm
        this.form.toxicity = data.data.toxicity
        this.form.packagingForm = data.data.packagingForm
        this.form.data = JSON.parse(data.data.data)
        if (this.form.type == '化肥') {
          let arr = [
            {
              label: '氮',
              value: '',
            },
            {
              label: '磷',
              value: '',
            },
            {
              label: '钾',
              value: '',
            },
            {
              label: '钙',
              value: '',
            },
            {
              label: '镁',
              value: '',
            },
            {
              label: '砷',
              value: '',
            },
            {
              label: '硼',
              value: '',
            },
          ]
          var i = 0
          this.form.data.forEach((item, index) => {
            Object.keys(item).forEach((itm) => {
              this.form.objContent[index][itm] = item[itm]
              arr[i].value = item[itm]
              i++
            })
          })
          arr.forEach((item) => {
            if (item.value != '') {
              this.form.checkList.push(item.label)
            }
          })
        } else if (this.form.type == '农药') {
          this.form.biocideOption = this.form.data
          this.form.biocideOption.forEach((item, index) => {
            item.forEach((i) => {
              if (i.value != '') {
                this.form.checkList.push(i.label)
              }
            })
          })
        }
      })
    },
    clearFrom() {
      this.$refs.form.resetFields()
    },
    save() {
      /**
       * 提交数据时，判断checkgroup选中与否，未选中的，对应输入框的值为空
       */
      if (this.form.id && this.form.type === '农药') {
        this.form.data.forEach((item) => {
          item.find((item) => {
            if (this.selectGroup.includes(item.label) !== true) {
              item.value = ''
            }
          })
        })
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.id) {
            if (this.form.type == '化肥') {
              this.form.data = JSON.stringify(this.form.objContent)
            } else {
              this.form.data = JSON.stringify(this.form.biocideOption)
            }
            addInputs(this.form)
              .then((data) => {
                this.$emit('inpuDatatGet')
                this.$message.success('提交成功')
                this.clearFrom()
              })
              .then(() => {
                this.$router.go(-1)
              })
          } else {
            this.form.data = []
            this.form.data.length = 3
            if (this.form.type == '化肥') {
              this.form.data = JSON.stringify(this.form.objContent)
            } else {
              this.form.data = JSON.stringify(this.form.biocideOption)
            }
            updateInputsById(this.form.id, this.form)
              .then((data) => {
                this.$message.success('提交成功')
                this.form.id = undefined
                this.clearFrom()
              })
              .then(() => {
                this.$router.go(-1)
              })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.size-icon {
  font-size: 100px;
  color: rgb(221, 100, 19);
}
.ingredientBox {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
}
.ingredient-item {
  width: 32%;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/resource/inputs/Edit.vue